import { visit } from 'unist-util-visit'
import type { Root } from 'mdast'

// remarkCallouts — maps `:::warn ... :::` containers (parsed by
// remark-directive) onto <div class="callout callout-warn">. Spec 19
// §2.4. The directive node already has the right children; we just
// flip hName / hProperties so the renderer emits a plain div.
//
// Future callout types (:::info, :::ok) plug in by extending the
// allowed names below. v2.0 ships only `warn`.

const ALLOWED = new Set(['warn'])

export function remarkCallouts() {
  return (tree: Root) => {
    visit(tree, (node: any) => {
      if (node.type !== 'containerDirective') return
      if (!ALLOWED.has(node.name)) return
      const data = node.data || (node.data = {})
      data.hName = 'div'
      data.hProperties = {
        className: ['callout', `callout-${node.name}`]
      }
    })
  }
}
